import { format } from "date-fns";

interface WhatsAppInvoiceParams {
  customerName?: string | null;
  customerPhone?: string | null;
  businessName: string;
  invoiceNumber?: string | null;
  totalAmount: number;
  date: string;
}

/**
 * Generate WhatsApp invoice sharing link with prefilled message
 */
export function generateWhatsAppInvoiceLink(params: WhatsAppInvoiceParams): string | null {
  const { customerPhone, customerName, businessName, invoiceNumber, totalAmount, date } = params;

  // Validate phone number
  const cleanPhone = customerPhone?.replace(/\D/g, "");
  if (!cleanPhone || cleanPhone.length < 10) {
    return null;
  }

  const formattedDate = format(new Date(date), "dd/MM/yyyy");
  
  const message = `Hello ${customerName || "Customer"},
Your invoice from *VLE Plus* is ready.

Invoice No: ${invoiceNumber || "DRAFT"}
Amount: ₹${Number(totalAmount).toLocaleString()}
Date: ${formattedDate}

Thank you for choosing VLE Plus!`;

  const encodedMessage = encodeURIComponent(message);
  
  // Add country code for India if not present
  const phoneWithCountry = cleanPhone.length === 10 ? `91${cleanPhone}` : cleanPhone;
  
  return `https://wa.me/${phoneWithCountry}?text=${encodedMessage}`;
}

/**
 * Generate bulk notification WhatsApp link
 */
export function generateBulkWhatsAppLink(
  phone: string,
  message: string,
  variables: Record<string, string>
): string | null {
  const cleanPhone = phone?.replace(/\D/g, "");
  if (!cleanPhone || cleanPhone.length < 10) {
    return null;
  }

  // Replace variables in message
  let personalizedMessage = message;
  Object.entries(variables).forEach(([key, value]) => {
    personalizedMessage = personalizedMessage.replace(new RegExp(`{{${key}}}`, "g"), value);
  });

  const encodedMessage = encodeURIComponent(personalizedMessage);
  const phoneWithCountry = cleanPhone.length === 10 ? `91${cleanPhone}` : cleanPhone;
  
  return `https://wa.me/${phoneWithCountry}?text=${encodedMessage}`;
}

/**
 * Open WhatsApp with invoice message
 */
export function openWhatsAppInvoice(params: WhatsAppInvoiceParams): boolean {
  const url = generateWhatsAppInvoiceLink(params);
  if (!url) {
    return false;
  }
  window.open(url, "_blank");
  return true;
}
